import { render, staticRenderFns } from "./SidePopover.vue?vue&type=template&id=4b1dc57f&scoped=true"
import script from "./SidePopover.vue?vue&type=script&lang=js"
export * from "./SidePopover.vue?vue&type=script&lang=js"
import style0 from "./SidePopover.vue?vue&type=style&index=0&id=4b1dc57f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1dc57f",
  null
  
)

export default component.exports